document.addEventListener("DOMContentLoaded", () => {
  const toggleBtn = document.getElementById("pricing-view-toggle");
  const cardsView = document.getElementById("pricing-cards");
  const tableView = document.getElementById("pricing-table");
  const iconContainer = document.getElementById("pricing-toggle-icon");
  const textContainer = document.getElementById("pricing-toggle-text");

  if (!toggleBtn || !cardsView || !tableView) return;

  // Icons
  const listIcon = `<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <line x1="8" y1="6" x2="21" y2="6"></line>
        <line x1="8" y1="12" x2="21" y2="12"></line>
        <line x1="8" y1="18" x2="21" y2="18"></line>
        <line x1="3" y1="6" x2="3.01" y2="6"></line>
        <line x1="3" y1="12" x2="3.01" y2="12"></line>
        <line x1="3" y1="18" x2="3.01" y2="18"></line>
    </svg>`;

  const gridIcon = `<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <rect x="3" y="3" width="7" height="7"></rect>
        <rect x="14" y="3" width="7" height="7"></rect>
        <rect x="14" y="14" width="7" height="7"></rect>
        <rect x="3" y="14" width="7" height="7"></rect>
    </svg>`;

  let isCardsView = true;

  toggleBtn.addEventListener("click", () => {
    isCardsView = !isCardsView;

    if (isCardsView) {
      // Show Cards
      cardsView.classList.add("active");
      tableView.classList.remove("active");

      // Set button to switch to Table
      iconContainer.innerHTML = listIcon;
      textContainer.textContent = "Tabelarni prikaz";
    } else {
      // Show Table
      tableView.classList.add("active");
      cardsView.classList.remove("active");

      // Set button to switch to Cards
      iconContainer.innerHTML = gridIcon;
      textContainer.textContent = "Prikaz kartica";
    }
  });
});
